<template>
    <!-- Модальне вікно підтвердженням видалення -->

    <dialogmodal>
        <template v-slot:body>
            <div class="row">
                <div 
                    v-for="items, index in this.onlineWorkers.filter(el => el.free === 'true')"
                    :key="index"
                    class="col-12"
                    style="display: flex; align-items: center"
                >
                    <span style="display: block; flex: 1; font-size: 16px">
                        {{items.user_id}}
                    </span>
                    <button 
                        style="display: block" 
                        class="btn bg-soft-success"
                        @click="refer(items.user_id)"
                    >
                        <i class='bx bx-transfer' style="color: green"></i>
                    </button>
                </div>
            </div>
        </template>
    </dialogmodal>
</template>

<script>
import dialogmodal from '@/components/modal/modalsave.vue'
import { ATS } from '@/API.js';  // клас для взаємодії з API 

let apiATS = new ATS()

export default {
    components: {
        dialogmodal
    },
    data(){
        return{
            onlineWorkers: []
        }
    },
    created(){
        this.getOnline()
    },
    methods: {
        refer(user) {
            let id = user.split(' ')[user.split(' ').length - 1].replace('(', '').replace(')', '')
            console.log(id, user.split(' '))
            this.eventBus.emit('chooseRefer', {user: id})
            this.$emit('close')
        },
        // отримуємо онлайн юзерів в АТС
        getOnline(){
            apiATS.getOnlineUsers().then(result => {
                if(result.status == 'done') {
                    this.onlineWorkers = result.data
                }
            })
        },
    }
}
</script>